import {useMutation} from "@tanstack/react-query";
import client from '../../utils/Client'




// CREATE A BRANCH
const submit = (payload) => client.post('branch', payload);
export const useCreateBranch = (payload) => useMutation(['createBranch'],() => submit(payload))

